import React from 'react'
// import { useTheme } from '@emotion/react'
import { Table } from '../base-ui'

function InfoGrid({ head = [], items = [] }) {
    // const theme = useTheme()
    const style = `
        width: 100%;
        border-radius: 0;
        thead {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
        th:last-child, th:first-of-type {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
        th, td {
            text-align: start;
        }
        td {
            padding: 1rem;
        }
        th {
            background-color: #c6dfff;
        }
        tr:last-child td:first-of-type, tr:last-child td:last-child, tbody {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }

    `
    return (
        <Table head={head} style={style}>
            {items.map((i, idx) => {
                return (
                    <tr key={idx}>
                        {i.map((ii, idx2) => (
                            <td key={idx2}>{ii}</td>
                        ))}
                    </tr>
                )
            })}
        </Table>
    )
}

export default InfoGrid
